<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2part"><a id="page_6"></a><a id="page_7">PART I</a><a id="page_8"></a></h2><a id="page_8">
<h2 class="h2partsub">THE LAST FRONTIER</h2>
<div class="group">
<h3 class="h3">UNALASKA, ALASKA</h3>
<div class="landscape">
<img alt="Image" src="images/f0007-01.jpg"/>
</div>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?2424102e